import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloPersonne,cleanAloPersonne } from '@/models/alo/AloPersonne'

export default {
  getAllPersonne(): AxiosPromise<AlrContainer<Array<AloPersonne>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Personne`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloPersonne>>
      }]
    })
  },
  getPersonne(id:number):AxiosPromise<AlrContainer<AloPersonne>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Personne/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloPersonne>
      }]
    })
  },
  savePersonne(personne:AloPersonne):AxiosPromise<AlrContainer<AloPersonne>> {
    cleanAloPersonne(personne)
    if(personne.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Personne/${personne.id}`, 
        method: 'PUT',
        data: personne,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPersonne>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/Personne`, 
        method: 'POST',
        data: personne,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloPersonne>
        }]
      })    
    }
  },
  deletePersonne(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/Personne/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}